import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { DivisionInterface } from './definitions/division-interface';
import { ErrorsInterface } from '../errors/errors-interface';
import { Observable } from 'rxjs';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface AddPartnerToEmployeeResponse {
  division: {
    addPartnerToEmployee: {
      output: DivisionInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class AddPartnerToEmployeeService {
  constructor(private apollo: Apollo) {}

  addPartnerToEmployee(
    partnerId: string,
    employeeId: string,
    divisionId: string,
    mutation: DocumentNode
  ): Observable<FetchResult<AddPartnerToEmployeeResponse>> {
    return this.apollo.mutate<AddPartnerToEmployeeResponse>({
      mutation: mutation,
      variables: {
        partnerId: partnerId,
        employeeId: employeeId,
        divisionId: divisionId,
      },
    });
  }
}
